import { NgZone } from "@angular/core";
import {
    initializeFaro,
    getWebInstrumentations,
    InternalLoggerLevel,
} from "@grafana/faro-web-sdk";

import { Context, Settings } from "@hermes/app-core";

export function faroInitializer(
    context: Context,
    settings: Settings,
    ngZone: NgZone,
) {
    return () => {
        if (context.isInBrowserMode() && settings.faroConfiguration) {
            const urlParameters = new URLSearchParams(window.location.search);
            const faroDebugEnabled = urlParameters.get("faro") === "debug";
            const { url, apiKey } = settings.faroConfiguration;
            ngZone.runOutsideAngular(() => {
                initializeFaro({
                    url,
                    apiKey,
                    app: {
                        name: "RDR",
                        environment: settings.envKey,
                    },
                    sessionTracking: {
                        samplingRate: settings.envKey === "prd" ? 0.1 : 1,
                    },
                    instrumentations: [
                        ...getWebInstrumentations({
                            captureConsole: true,
                            captureConsoleDisabledLevels: [],
                        }),
                    ],
                    internalLoggerLevel: faroDebugEnabled
                        ? InternalLoggerLevel.VERBOSE
                        : InternalLoggerLevel.OFF,
                });
            });
        }
        return Promise.resolve();
    };
}
